import { render, staticRenderFns } from "./CandidateConversation.vue?vue&type=template&id=0ca3596a&scoped=true&"
import script from "./CandidateConversation.vue?vue&type=script&lang=js&"
export * from "./CandidateConversation.vue?vue&type=script&lang=js&"
import style0 from "./CandidateConversation.vue?vue&type=style&index=0&id=0ca3596a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca3596a",
  null
  
)

export default component.exports